import React from 'react';

import {  Table ,Modal, message, Input } from 'antd';

import {verifIsLogged, setDisconnectMachineId, getFrDateFormat, getMachineId, getBaseURL, getLanguage, getPays, setLanguage} from "../util/Toolbox";

import { withTranslation } from 'react-i18next';

import './css/historique.css';


import './css/navBar.css';

import picto_home             from './assets/home/picto_home.png';

import axios from '../util/Api'

import {
  EditOutlined,
  SearchOutlined,
  CloudDownloadOutlined,
  ShareAltOutlined,
  DeleteOutlined

} from '@ant-design/icons';

class Historique extends React.Component {

  state = {
    historique_LIST : [],
    search : '',
    guid_compte: 'fsdfsdsdfsdfsd',
    editionKey : '',
    inputValue : '',
    stateConfirmeDelete : false,
    analyseCurrent : null,
    isLoading : false,
    baseURL : '',
    language : getLanguage(),
    languages_LIST : []

  }

  handleSearch = (pe_search) => {
    this.state.search = pe_search;
    this.loadHistorique();
  };


  async componentDidMount() {

    verifIsLogged();

    let guid_compte = getMachineId();

    let languages_LIST = getPays();
    this.setState({languages_LIST : languages_LIST});

    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});
    

    const search  = window.location.search;
    const params  = new URLSearchParams(search);

    let baseURL = getBaseURL();
    this.setState({baseURL});

   

    this.state.guid_compte = guid_compte;
    this.loadHistorique();
    
}



      // Fonction pour changer la langue
handleChangeLanguage = (event) => {
    const newLang = event.target.value;
    // Définir la langue  
    const {i18n } = this.props;
    console.log(newLang);
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});
  };


  loadHistorique(){

  
    let search = '-1';

    if(this.state.search != ''){
      search = this.state.search;
    }

    this.setState({isLoading : true})
    axios.get(`analyse/${this.state.guid_compte}/${search}/historique`,
    ).then(({data}) => {
      console.log(data);

      if(data.success == 'success'){
        this.setState({historique_LIST : data.result, isLoading : false});
      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
      this.setState({isLoading : false})
    });

  }


  consulterAnalyse(item){

    window.location.href= '/analyse?analyse='+ item.GUID_Analyse;
  }


  telechargerAnalyse(item){
    message.info("Cette fonctionalité pas encore disponible")
    return
 
  }


  partagerAnalyse(item){


    console.log(item);
    let url = `${this.state.baseURL}/analyse/${item.GUID_Analyse}/printAnalyse`;
    console.log(this.state.baseURL + url)

    let htmlEmail = `

      Cliquer sur le lien ci dessous pour visualiser l'analyse ${item.GUID_Analyse}
      ${url}

    `

    window.open(`mailto:?subject=Pool Solutions - Partage analyse&body=${encodeURIComponent(htmlEmail)}`);


  }

  supprimerAnalyse(item){
    console.log(item);
    this.setState({stateConfirmeDelete : true, analyseCurrent : item})

  }

  confirmDeleteAnalyse(){

    

    axios.get(`analyse/${this.state.analyseCurrent.GUID_Analyse}/deleteAnalyse`,
    ).then(({data}) => {

      console.log(data);
      this.loadHistorique();

    }).catch(function (error) {
      console.log("Error****:", error.message);
    });


    this.cancelDeleteAnalyse();

  }

  cancelDeleteAnalyse(){
  
    this.setState({stateConfirmeDelete : false})
  }

  editRow(item){

    this.setState({editionKey : item.GUID_Analyse , inputValue : item.ReferenceAnalyse});
  }


  handleChange(inputValue) {
    this.setState({inputValue});
  }

  saveItem() {

 

    let GUID_Analyse       = this.state.editionKey;
    let historique_LIST    = [...this.state.historique_LIST] ;
    let ReferenceAnalyse   = this.state.inputValue ;

    console.log(ReferenceAnalyse);


    for (var i = 0; i < historique_LIST.length; i++) {
      if(historique_LIST[i].GUID_Analyse == GUID_Analyse){
        historique_LIST[i].ReferenceAnalyse = ReferenceAnalyse;
      }
    }

    axios.post('/analyse/updateHistorique', {historique : {GUIDAnalyse : this.state.editionKey, LibelleAnalyse : this.state.inputValue } },
    ).then(({data}) => {
      this.setState({editionKey : '', inputValue : '', historique_LIST : historique_LIST })
    }).catch(function (error) {
      console.log("Error****:", error.message);
      message.error("Erreur lors de l'analyse");
    });

  }

  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      const columns = [

        {
            title: 'Référence',
            dataIndex: 'ReferenceAnalyse',
            width: '30%',
            sorter: (a, b) => a.ReferenceAnalyse.localeCompare(b.ReferenceAnalyse),
            render: (text, record) => (
              <span  style = {{color : record.ReferenceAnalyse == ''? "grey" : ""   }} onClick={() => this.editRow(record) }>

                {this.state.editionKey === record.GUID_Analyse ?
                <Input
                  defaultValue= {this.state.inputValue}
                  allowClear={true}
                  autoFocus
                  onChange={(event) => this.handleChange(event.target.value)}
                  onPressEnter={() => this.saveItem()}
                />
                  : record.ReferenceAnalyse == '' ? "Cliquer pour éditer" : record.ReferenceAnalyse}

              </span>
            )
        },

        {
            title: 'Date',
            dataIndex: 'LibelleHistorique',
            render: (text, record) => (
              <span>
                {getFrDateFormat(record.DateAnalyse)}
              </span>
            ),
            sorter: (a, b) => a.DateAnalyse.localeCompare(b.DateAnalyse),
            width: '20%'
        },

        {
            title: '',
            dataIndex: 'Consulter',
            width: '5%',
            render: (text, record) => (
              <span onClick={() => this.consulterAnalyse(record)}>
                <SearchOutlined style={{color: '#2B4570', fontSize: '20px', cursor: 'pointer'}} type="edit"/>
              </span>
            )
        },

        {
            title: '',
            dataIndex: 'dowlnoad',
            width: '5%',
            render: (text, record) => (
              <span onClick={() => this.telechargerAnalyse(record)}>

              <a style={{textDecoration: 'none', color : '#0093CF'}} target="_blank" href={`${this.state.baseURL}/analyse/${record.GUID_Analyse}/printAnalyse`}>
                <CloudDownloadOutlined style={{color: '#2B4570', fontSize: '20px', cursor: 'pointer'}} type="edit"/>
              </a>


              </span>
            )
        },

        {
            title: '',
            dataIndex: 'Share',
            width: '5%',
            render: (text, record) => (
              <span onClick={() => this.partagerAnalyse(record)}>
                <ShareAltOutlined style={{color: '#2B4570', fontSize: '20px', cursor: 'pointer'}} type="edit"/>
              </span>
            )
        },

        {
            title: '',
            dataIndex: 'Historique',
            width: '5%',
            render: (text, record) => (
              <span onClick={() => this.supprimerAnalyse(record)}>
                <DeleteOutlined style={{color: '#707070', fontSize: '20px', cursor: 'pointer'}} type="edit"/>
              </span>
            )
        }

    ];

  
      return (

        <div>

          <div className = "wrapper_historique">

            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

            <nav>
                  <ul>
                      <li><a href = "/"><img loading="lazy" src={picto_home} width ="180px"/></a></li>
                      <li><a style = {{marginTop : 10}} href="/forms">{t('menu_analyse')}</a></li>
                      <li><a href="/simulateur">{t('menu_calcul_volume')}</a></li>
                      <li><a href="/historique">{t('menu_historique')}</a></li>
                      <li> <span onClick={setDisconnectMachineId}> <a href="#">{t('menu_login') } </a> </span>  </li>

                      <li> 
                        <select
                          id="language-select"
                          value={this.state.language}
                          disabled = {false}
                          onChange={this.handleChangeLanguage}
                          style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
                        >
                          {this.state.languages_LIST.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.flag} {lang.label}
                            </option>
                          ))}
                        </select>  
                      </li>

                  </ul>
            </nav>
        

            <div className = "containersHistorique">

            <Input onChange={(event) => this.handleSearch(event.target.value)}  style = {{marginTop:12}} placeholder= {t('histo_search')} />

            {
              this.state.stateConfirmeDelete == true &&

              <Modal
                title={t('historique_message_supression_title')}
                open={this.state.stateConfirmeDelete}
                onOk={this.confirmDeleteAnalyse.bind(this)}
                onCancel={this.cancelDeleteAnalyse.bind(this)}
                okText= {t('historique_message_supression_button_supprimer')}
                cancelText={t('historique_message_supression_button_annuler')}
              >
                <p>{t('historique_message_supression_description')}</p>
              </Modal>

            }

            <Table
              className = "historique_table"
              columns={columns}
              size="small"
              dataSource={this.state.historique_LIST}
              pagination={false}
              bordered = {false}
              sticky={true}
              loading = {this.state.isLoading}
              scroll={{y:"calc(100vh - 300px)" }}
            />

            </div>

          </div>

       

        </div>

      )

    };
}



export default withTranslation() (Historique);
